module.exports = __webpack_public_path__ + "img/logo-acconomy_symbol-textured.351b6862.svg";